import { render, staticRenderFns } from "./ConfigAuth.vue?vue&type=template&id=a2d372ae&scoped=true&"
import script from "./ConfigAuth.vue?vue&type=script&lang=js&"
export * from "./ConfigAuth.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAuth.vue?vue&type=style&index=0&id=a2d372ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d372ae",
  null
  
)

export default component.exports